/**
 * Created by nelson_castillo on 2/13/17.
 */
import('jquery-circle-progress');

let message1;
let message2;
let go1 = false;
let go2 = false;
let go3 = false;
$(() => {
  const image = `${window.location.protocol}//${window.location.host}/wp-content/plugins/speed-manager/images/`;
  const image1 = `${image}gz.png`;
  const image2 = `${image}other.png`;
  const image3 = `${image}load.png`;
  let circle;
  let circle2;
  let width;
  let width2;

  function makeCircle() {
    $('#circle_group').removeClass('invisible');
    circle = $('#info1');
    circle2 = $('#info2');
    width = circle.width();
    width2 = circle2.width();
    if (width < 350) { width = '350px'; }
    if (width2 < 350) { width2 = '350px'; }
    $('#circle1').css(
      {
        width,
        height: width,
      },
    );
    $('#circle2').css(
      {
        width,
        height: width2,
      },
    );
    width = $('#circle1').width();
    width2 = $('#circle2').width();
  }
  function applyCss() {
    const theParent = $('#speed');
    width = $('#circle1').width();
    width2 = $('#circle2').width();
    theParent.css(
      {
        'align-content': 'center',
        'align-items': 'center',
        'text-align': 'center',
      },
    );
    theParent.find('#go').css(
      {
        'margin-left': 'auto',
        'margin-right': 'auto',
        'margin-top': '5px',
        width: '260px',
        color: '#000',
      },
    );
    theParent.find('#all_in_gbzone').css(
      {
        'margin-bottom': '10px',
        'text-align': 'center',
      },
    );
    theParent.find('#info1').css(
      {
        'text-align': 'center',
      },
    );
    theParent.find('#text1').css(
      {
        'font-weight': '900',
        color: 'black',
        'font-size': '16px',
        'text-align': 'center',
      },
    );
    theParent.find('#text2').css(
      {
        'font-weight': '900',
        color: 'black',
        'font-size': '16px',
        'text-align': 'center',
      },
    );
    theParent.find('#text2').css(
      {
        'text-align': 'center',
      },
    );
    theParent.find('#canvas1Text').css(
      {
        'text-align': 'center',
        display: 'inline-block',
        'max-width': '220px',
        'min-width': '220px',
        width: '220px',
        'z-index': '3',
      },
    );
    theParent.find('#canvas2Text').css(
      {
        'text-align': 'center',
        display: 'inline-block',
        'max-width': '220px',
        'min-width': '220px',
        width: '220px',
        'z-index': '3',
      },
    );
    theParent.find('.selection label').css(
      {
        'text-align': 'center',
        width: '100%',
      },
    );
    theParent.find('.selection input').css(
      {
        'text-align': 'center',
        width: '100%',
      },
    );
    theParent.find('.selection select').css(
      {
        'text-align': 'center',
        width: '100%',
      },
    );
    theParent.find('.theCanvas').css(
      {
        display: 'block',
        padding: '0',
        // 'padding': '20px',
        'background-color': 'rgba(0,0,0,0)',
        '-moz-border-radius': '0',
        '-webkit-border-radius': '0',
        '-khtml-border-radius': '0',
        'border-radius': '0',
        // 'border':'5px solid black',
        // 'border-top':'5px solid black',
        // 'border-left':'5px solid black',
        // 'border-right':'5px solid black',
        'text-align': 'center',
        'align-content': 'center',
        height: width,
        width,
      },
    );
    theParent.find('canvas').css(
      {
        display: 'block',
        'text-align': 'center',
        'margin-left': 'auto',
        'margin-right': 'auto',
      },
    );
    // console.log(image);
    theParent.find('#circle1').css(
      {
        'background-image': `url(${image1})`,
        'background-size': 'contain',
        'background-repeat': 'no-repeat',
        height: width,
        width,
      },
    );
    // console.log(image);
    theParent.find('#circle2').css(
      {
        'background-image': `url(${image2})`,
        'background-size': 'contain',
        'background-repeat': 'no-repeat',
        height: width2,
        width,
      },
    );
    theParent.find('#info1 strong').css(
      {
        'text-align': 'center',
        width: '100%',
        'font-weight': '900',
        'font-size': '14px',
      },
    );
    theParent.find('#info2 strong').css(
      {
        'text-align': 'center',
        width: '100%',
        'font-weight': '900',
        'font-size': '14px',
      },
    );
  }
  $(window).resize(() => {
    applyCss();
    // $("#circle_group").addClass("invisible");
    // if(go2 || go3) {
    makeCircle();
    // }
    if (go1) {
      $('#go').trigger('click');
    }
  });
  $('#go').click(() => {
    applyCss();
    makeCircle();
    applyCss();
    makeCircle();
    go1 = true;
    go2 = true;
    go3 = true;
    // console.log(width);
    const pb_speed = parseFloat($('#pb_selection').val());
    const others_speed = parseFloat($('#others_selection').val());
    const bytes_total = parseFloat($('#size_selection').val());
    // console.log(pb_speed, others_speed, bytes_total);
    const pb_sp = ((bytes_total * 1.024) / (pb_speed)) * 8; // 8 is because 1mb dowload at 1mbit per second takes 8 secs same as 1gb download at 1gbit /sec speed takes 8 seconds
    const ot_sp = ((bytes_total * 1.024) / (others_speed)) * 8;
    const min_pb = Math.floor(pb_sp / 60);
    const sec_pb = pb_sp - (min_pb * 60);
    const hour_ot = Math.floor(ot_sp / 3600);
    const min_ot = Math.floor((ot_sp - (hour_ot * 3600)) / 60);
    const sec_ot = ot_sp - (hour_ot * 3600) - (min_ot * 60);
    message1 = 'With the GigaZone this download will take approximately<br>';
    message2 = 'With the selected connection this download will take approximately<br>';
    if (min_pb > 0) {
      message1 += min_pb;
      if (min_pb !== 1) {
        message1 += ' minutes ';
      } else {
        message1 += ' minute ';
      }
    }

    if (sec_pb > 0) {
      if ((sec_pb % 1) === 0) {
        message1 += sec_pb;
      } else {
        message1 += sec_pb.toFixed(2);
      }
      if (sec_pb !== 1) {
        message1 += ' seconds';
      } else {
        message1 += ' second';
      }
    }
    if (hour_ot > 0) {
      message2 += hour_ot;
      if (hour_ot !== 1) {
        message2 += ' hours ';
      } else {
        message2 += ' hour ';
      }
    }
    if (min_ot > 0) {
      message2 += min_ot;
      if (min_ot !== 1) {
        message2 += ' minutes ';
      } else {
        message2 += ' minute ';
      }
    }
    if (sec_ot > 0) {
      if ((sec_ot % 1) === 0) {
        message2 += sec_ot;
      } else {
        message2 += sec_ot.toFixed(2);
      }
      if (sec_ot !== 1) {
        message2 += ' seconds';
      } else {
        message2 += ' second';
      }
    }
    const difference = pb_speed / others_speed;
    const in_progress = 'In progress.';
    let done_gz = 'Done! lets now wait for them.';
    const done_gz1 = 'Say goodbye to buffering with fast internet!.';
    const done_gz2 = 'The internet should be fast, not furious!.';
    const done_gz3 = 'Slow internet is so last century!.';
    const done_gz4 = 'Time is too precious to wait for internet!.';
    const done_gz5 = 'Slow internet? We can do better. Discover what you\'re missing!.';
    const done_gz6 = 'Don\'t let slow internet slow you down!.';
    $('#span_differences').removeClass('invisible');
    if (difference % 1 === 0) {
      $('#difference').html(difference);
    } else {
      $('#difference').html(Math.round(difference * 100) / 100);
    }
    const duration_by = 1000;
    const strong1 = $('#circle1').parent('div').find('strong');
    const strong2 = $('#circle2').parent('div').find('strong');

    let d_dots_counter = 0;
    let count_expressions = 0;
    let d_dots = '';
    let last2 = '';
    let last1 = '';
    function get_t(t) {
      if (t === 1) {
        return done_gz2;
      } if (t === 2) {
        return done_gz3;
      } if (t === 3) {
        return done_gz4;
      } if (t === 4) {
        return done_gz5;
      } if (t === 5) {
        return done_gz6;
      }
      return done_gz1;
    }
    function d_dots_f() {
      if (d_dots_counter === 0) {
        d_dots = '.';
      } else if (d_dots_counter === 1) {
        d_dots = '..';
      } else {
        d_dots_counter = -1;
        d_dots = '';
        if (count_expressions > 4) {
          let t = Math.floor((Math.random() * 10) + 1) % 6;
          done_gz = get_t(t);
          if (done_gz === last1 || done_gz === last2) {
            done_gz = get_t(t + 1);
            if (done_gz === last1 || done_gz === last2) {
              done_gz = get_t(t + 1);
              if (done_gz === last1 || done_gz === last2) {
                t = Math.floor((Math.random() * 10) + 1) % 6;
                done_gz = get_t(t);
              }
            }
          }
          last2 = last1;
          last1 = done_gz;
          count_expressions = 0;
        }
      }
      count_expressions++;
      d_dots_counter++;
    }
    const myInterval = setInterval(() => { d_dots_f(); }, 1000);
    $('#circle1').circleProgress({
      value: 0.5,
      thickness: width / 2,
      insertMode: 'append',
      size: width,
      animation: {
        duration: pb_sp * duration_by,
      },
      emptyFill: 'rgba(100,0,0,0.0)',
      fill: {
        image: image3,
      },
    }).on('circle-animation-progress', (event, progress) => {
      if (progress === 1) {
        $(strong1).html(done_gz + d_dots);
        go2 = false;
        if (go3 === false) {
          go1 = false;
          clearInterval(myInterval);
        }
      } else {
        $(strong1).html(in_progress + d_dots);
      }
    });

    $('#circle2').circleProgress({
      value: 0.5,
      thickness: width / 2,
      insertMode: 'append',
      size: width2,
      animation: {
        duration: ot_sp * duration_by, // we are looking for a load of 50% of the image to mark 100% so we multiple by 4
      },
      emptyFill: 'rgba(0,100,0,0.0)',
      fill: {
        image: image3,
      },
    }).on('circle-animation-progress', (event, progress) => {
      if (progress === 1) {
        go3 = false;
        if (go2 === false) {
          go1 = false;
          $(strong1).html('Done!, no more waiting...');
          $(strong2).html('Done! sorry for the wait...');
          clearInterval(myInterval);
        }
      } else {
        $(strong2).html(in_progress + d_dots);
        if (!go2) {
          $(strong1).html(done_gz + d_dots);
        }
      }
    });

    $('#text1').html(message1);
    $('#text2').html(message2);
  });
  applyCss();
});
